import styles from "./FileIcon.module.css";

const getExt = (value) => value.split(".").pop();

const getDisplayName = (item) => {
  if (item.type === "folder") return item.name;
  if (item.type === "text") return `${item.name}.txt`;
  if (item.type === "image") return `${item.name}.${getExt(item.value)}`;
  return item.name;
};

const FileIcon = ({ item, isSelected, onSelect, onOpen }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onSelect();
  };

  const handleDoubleClick = (e) => {
    e.stopPropagation();
    onOpen(item);
  };

  return (
    <div
      className={styles.icon}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
    >
      <div className={`${styles.iconWrapper} ${isSelected ? styles.selectedWrapper : ""}`}>
        {item.type === "folder" && (
          <img src="/folder.png" alt="folder" className={styles.folderImg} />
        )}
        {item.type === "text" && (
          <div className={styles.textFile}>
            <pre className={styles.textPreview}>{item.value}</pre>
          </div>
        )}
        {item.type === "image" && (
          <div className={styles.imageFile}>
            <img src={item.value} alt={item.name} className={styles.imageThumb} />
          </div>
        )}
      </div>
      <span className={`${styles.label} ${isSelected ? styles.selectedLabel : ""}`}>
        {getDisplayName(item)}
      </span>
    </div>
  );
};

export default FileIcon;
